import React from "react";

type IconProps = { className?: string };

const baseProps = {
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export function IconDashboard({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3v-6h6v6h3a1 1 0 001-1V10" />
    </svg>
  );
}

export function IconMatches({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18M9 4v16" />
    </svg>
  );
}

export function IconPlayers({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 19c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M14 19c0-2.5 1.5-4.5 4-5" />
    </svg>
  );
}

export function IconIndoor({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M3 21V8l9-5 9 5v13" />
      <path d="M9 21v-6h6v6" />
      <path d="M3 12h18" />
    </svg>
  );
}

export function IconT20({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
    </svg>
  );
}

export function IconODI({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M8 21h8M12 17v4M7 4h10v6a5 5 0 01-10 0V4z" />
      <path d="M17 5h3v2a3 3 0 01-3 3M7 5H4v2a3 3 0 003 3" />
    </svg>
  );
}

export function IconLeagues({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M8 21h8M12 17v4M7 4h10v6a5 5 0 01-10 0V4z" />
    </svg>
  );
}

export function IconBug({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <rect x="8" y="6" width="8" height="14" rx="4" />
      <path d="M12 6V4M9 5l-2-2M15 5l2-2" />
      <path d="M8 10H4M8 14H3M8 18H4M20 10h-4M21 14h-5M20 18h-4" />
      <path d="M12 6v14" />
    </svg>
  );
}

export function IconHelp({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 015 0c0 1.5-2.5 2-2.5 3.5M12 17v.5" />
    </svg>
  );
}

export function IconBook({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M4 4h7a2 2 0 012 2v14a2 2 0 00-2-2H4z" />
      <path d="M20 4h-7a2 2 0 00-2 2v14a2 2 0 012-2h7z" />
    </svg>
  );
}

export function IconDoc({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M6 2h8l4 4v16a0 0 0 01 0 0H6a0 0 0 01 0 0V2z" />
      <path d="M14 2v4h4M8 12h8M8 16h8M8 8h4" />
    </svg>
  );
}

export function IconInfo({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v.5M11 12h1v4h1" />
    </svg>
  );
}

export function IconProfile({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
    </svg>
  );
}

export function IconSettings({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 00.3 1.9l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.9-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.9.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.9 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.9l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.9.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.9-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.9V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />
    </svg>
  );
}

export function IconSignOut({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
      <path d="M16 17l5-5-5-5M21 12H9" />
    </svg>
  );
}

export function IconClose({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

export function IconPlus({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  );
}

export function IconMore({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="5" cy="12" r="1.5" />
      <circle cx="12" cy="12" r="1.5" />
      <circle cx="19" cy="12" r="1.5" />
    </svg>
  );
}

export function IconHome({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3v-6h6v6h3a1 1 0 001-1V10" />
    </svg>
  );
}

export function IconShield({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <path d="M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5l8-3z" />
    </svg>
  );
}

export function IconBall({ className }: IconProps) {
  return (
    <svg className={className ?? "w-5 h-5"} {...baseProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 3v18M3 12h18" />
    </svg>
  );
}
